// Helper function to format date as "DD MMM YYYY"
export const formatDate = (date: Date): string =>
    date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });

export const getYears = () => {
    const currentYear = new Date().getFullYear();
    const years: number[] = [];

    for (let i = currentYear; i >= 2012; i--) {
        years.push(i);
    }

    return years;
};
